import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

const TableSentCalls = ({ getRows }) =>  {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport } = getItensStateGlobal;

  let { sendedsResume  } = storageDataReport;
  if (!sendedsResume) sendedsResume = { all: 0, ans: 0, nans: 0, busy: 0, failed: 0, time: '00:00:00', avr: '00:00:00' };

  const {
    all,
    time,
    avr,
    ans,
    busy,
    failed,
    nans,
    onhold
  } = sendedsResume;

  return (
    <div className="column is-half">
      <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr className='has-background-success'>
            <th className='has-text-primary-light is-spaced has-text-centered' colSpan="2">Contatos Realizados</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Contatos</td>
            <th className='is-clickable'><Link to="#" className='has-text-black' onClick={ () => getRows('sendeds-table', 'recebida', '') } >{ all }</Link></th>
          </tr>
          <tr>
            <td>Total Contatos Atendidos</td>
            <th className='is-clickable'><Link to="#" className='has-text-black' onClick={ () => getRows('sendeds-table', 'recebida', 'atendida') } >{ ans }</Link></th>
          </tr>
          <tr>
            <td>Total Contatos Não Atendidos</td>
            <th className='is-clickable'><Link to="#" className='has-text-black' onClick={ () => getRows('sendeds-table', 'recebida', 'perdida') } >{ nans }</Link></th>
          </tr>
          <tr>
            <td>Total Contatos Ocupados</td>
            <th className='is-clickable'><Link to="#" className='has-text-black' onClick={ () => getRows('sendeds-table', 'recebida', 'ocupado') } >{ busy }</Link></th>
          </tr>
          <tr>
            <td>Total Contatos Falha</td>
            <th className='is-clickable'><Link to="#" className='has-text-black' onClick={ () => getRows('sendeds-table', 'recebida', 'falha') } >{ failed }</Link></th>
          </tr>
          <tr>
            <td>Duração Total das Chamadas</td>
            <th>{ time }</th>
          </tr>
          <tr>
            <td>Tempo Médio das Chamadas</td>
            <th>{ avr }</th>
          </tr>
          <tr>
            <td>Tempo Médio na Espera</td>
            <th>{ onhold }</th>
          </tr>
        </tbody>
      </table>
    </div>
  )
};

export default TableSentCalls;
